<template>
    <v-card>
        <v-card-title>
        <span class="headline">Travel Area Detail</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
        <form>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs6 v-if="newArea">
                <v-text-field :label="labels.area" v-model="areaForm.area" :error-messages="errors.collect('area')" data-vv-name="area" :data-vv-as="labels.area" v-validate="'required|param|max:2'"></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.area}}</v-subheader>
                <div class="title">{{areaForm.area}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="areaForm.description" :label="labels.description" :error-messages="errors.collect('description')" v-validate="'required|entry|max:40'" data-vv-name="description" :data-vv-as="labels.description"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="areaForm.ranking" :label="labels.ranking" :error-messages="errors.collect('ranking')" v-validate="'integer|max:10|required'" data-vv-name="ranking" :data-vv-as="labels.ranking"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel">Cancel</v-btn>
        <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  props: {
    'areaForm': Object,
    'newArea': Boolean
  },
  data() {
    return {
      labels: {
        area: 'Area Code*',
        description: 'Description*',
        ranking: 'Ranking*'
      },
      submitting: undefined
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.areaForm.area = undefined
      this.areaForm.description = undefined
      this.areaForm.ranking = undefined
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newArea) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.travel.menu.createTravelArea
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.areaForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.travel.menu.updateTravelArea
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.areaForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.doInit()
      this.$emit('close')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
